import styled from 'styled-components';

export default styled.div`
  .config-product-name {
    font-size: 20px;
    .brand {
      font-weight: bold;
      &::after {
        content: " ";
      }
    }
  }
`;
